/* eslint @typescript-eslint/naming-convention: 0 */
import type { MapSourcePage } from '@/wabunka-src/common/utils/googleAnalytics/common/mapSearch';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * is_cluster を判別子にした union 型。
 * ピンタップ（is_cluster=false）は experience_id（体験 slug。purchase の item_id と突合）必須、
 * クラスタタップ（is_cluster=true）は experience_id なし、をコンパイル時に保証する。
 */
export type MapPinClickParams = { source_page: MapSourcePage; is_cluster: true; experience_id?: never } | { source_page: MapSourcePage; is_cluster: false; experience_id: string };

export type MapPinClickInput = { sourcePage: MapSourcePage } & ({ isCluster: true; experienceId?: never } | { isCluster: false; experienceId: string });

const buildMapPinClickParams = (input: MapPinClickInput): MapPinClickParams => {
  if (input.isCluster) {
    return { source_page: input.sourcePage, is_cluster: true };
  }
  return { source_page: input.sourcePage, is_cluster: false, experience_id: input.experienceId };
};

/**
 * 発火タイミング：マップのピン（→プレビューカード表示）またはクラスタをタップした際。
 * マップ起点回遊の起点。ダッシュボードのブロック④⑤で使用（JCAT-4824）。
 */
export const sendGAWabunkaMapPinClickEvent = (input: MapPinClickInput) => {
  sendWabunkaGAEvent('map_pin_click', buildMapPinClickParams(input));
};
